import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { AffiliatesLink } from './AffiliatesLink';

interface HowToStartGuideProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const HowToStartGuide = ({ variant }: HowToStartGuideProps) => (
  <AffiliatesLink variant={variant} path="/fiverr-affiliates-start-guide/" category={'How To Start Guide'}>
    <I18n k="affiliates_signup_perseus.support.how_to_start_guide" />
  </AffiliatesLink>
);
